import React, { useState } from 'react';

import { urlToFilingPath } from '../utils/sec-url';

export function LandingPage(): React.ReactElement {
  const [url, setUrl] = useState('');

  const handleGo = (e: React.FormEvent): void => {
    e.preventDefault();
    if (!url.trim()) return;

    const filingPath = urlToFilingPath(url.trim());
    const params = new URLSearchParams();
    if (filingPath) {
      params.set('f', filingPath);
    } else {
      params.set('url', url.trim());
    }
    window.location.search = params.toString();
  };

  return (
    <div
      className='h-screen flex items-center justify-center'
      style={{
        background:
          'linear-gradient(135deg, #0f2947 0%, #1a3a5c 50%, #0f2947 100%)',
      }}
    >
      <div className='text-center max-w-lg px-8'>
        <h1 className='text-3xl font-semibold text-white mb-2'>
          Meridian Source Viewer
        </h1>
        <p className='text-sm mb-8 text-[#94a3b8]'>
          View and navigate SEC EDGAR filings with highlighted values
        </p>

        <form onSubmit={handleGo} className='mb-8'>
          <div className='flex gap-2'>
            <input
              type='text'
              value={url}
              onChange={e => setUrl(e.target.value)}
              placeholder='Paste a SEC EDGAR filing URL...'
              className='flex-1 px-4 py-3 rounded-lg text-sm bg-white/8 border border-white/15 text-white outline-none'
            />
            <button
              type='submit'
              disabled={!url.trim()}
              className='px-5 py-3 rounded-lg text-sm font-medium text-white transition-colors disabled:opacity-40 bg-accent hover:bg-[#2563eb]'
            >
              View Filing
            </button>
          </div>
        </form>

        <div className='p-5 rounded-xl text-left bg-white/5'>
          <p className='text-xs font-medium mb-3 uppercase tracking-wide text-slate-500'>
            URL Formats
          </p>
          <div className='space-y-2'>
            <div>
              <p className='text-xs mb-1 text-slate-500'>XBRL (preferred)</p>
              <code className='text-xs text-[#94a3b8]'>
                ?f=
                <span className='text-blue-400'>{'<filing_path>'}</span>
                &tag=
                <span className='text-blue-400'>{'<xbrl_tag>'}</span>
                &end=
                <span className='text-blue-400'>{'<period_end_date>'}</span>
              </code>
            </div>
            <div>
              <p className='text-xs mt-2 mb-1 text-slate-500'>
                Text search (legacy)
              </p>
              <code className='text-xs text-[#94a3b8]'>
                ?f=
                <span className='text-blue-400'>{'<filing_path>'}</span>
                &s=
                <span className='text-blue-400'>{'<search_text>'}</span>
                &i=
                <span className='text-blue-400'>{'<instance>'}</span>
              </code>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
